import { useColorModeValue } from "@/components/ui/color-mode"
import { colors } from "@/theme"
import { forwardRef } from "react"

export interface VisionSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  variant?: "glass" | "outline" | "solid"
}

export const VisionSelect = forwardRef<HTMLSelectElement, VisionSelectProps>(
  ({ variant = "glass", style, ...props }, ref) => {
    const isLight = useColorModeValue(true, false)

    const bg = isLight
      ? variant === "glass"
        ? "white"
        : variant === "solid"
          ? "#EDF2F7"
          : "transparent"
      : variant === "glass"
        ? colors.glass.dark
        : variant === "solid"
          ? "rgb(19,21,54)"
          : "transparent"

    const borderColor = isLight ? "#E2E8F0" : colors.glass.whiteAlpha[200]
    const color = isLight ? "#1a202c" : "white"

    return (
      <select
        ref={ref}
        style={{
          background: bg,
          border: `1px solid ${borderColor}`,
          color,
          fontWeight: 500,
          fontSize: "0.875rem",
          height: "40px",
          padding: "0 12px",
          borderRadius: "12px",
          width: "100%",
          outline: "none",
          cursor: "pointer",
          appearance: "auto",
          ...style,
        }}
        {...props}
      />
    )
  },
)

VisionSelect.displayName = "VisionSelect"
